export interface IPlansType {
  label: string;
  value: string;
}

export const plansTypeArr: IPlansType[] = [
  {
    label: 'Todos',
    value: 'UNDEFINED',
  },
  {
    label: 'Gps',
    value: 'only_gps',
  },
  {
    label: 'Gps + Assistência',
    value: 'assist_plus_gps',
  },
  {
    label: 'Assistência',
    value: 'assist',
  },
];
